import { cache } from 'react';
import { APP_CONFIG_DEFAULTS } from '@/app-config';
export const CONFIG_ENDPOINT = process.env.NEXT_PUBLIC_APP_CONFIG_ENDPOINT;
export const SANDBOX_ID = process.env.SANDBOX_ID;
export const THEME_STORAGE_KEY = 'theme-mode';
export const THEME_MEDIA_QUERY = '(prefers-color-scheme: dark)';
export function getOrigin(headers) {
    const host = headers.get('host');
    const proto = headers.get('x-forwarded-proto') || 'https';
    return `${proto}://${host}`;
}
// https://react.dev/reference/react/cache#caveats
// > React will invalidate the cache for all memoized functions for each server request.
export const getAppConfig = cache(async (origin) => {
    if (CONFIG_ENDPOINT) {
        const sandboxId = SANDBOX_ID !== null && SANDBOX_ID !== void 0 ? SANDBOX_ID : origin.split('.')[0];
        try {
            const response = await fetch(CONFIG_ENDPOINT, {
                cache: 'no-store',
                headers: { 'X-Sandbox-ID': sandboxId },
            });
            const remoteConfig = await response.json();
            const config = Object.assign({}, APP_CONFIG_DEFAULTS);
            for (const [key, entry] of Object.entries(remoteConfig)) {
                if (entry === null)
                    continue;
                if (key in config &&
                    typeof config[key] === entry.type &&
                    typeof config[key] === typeof entry.value) {
                    // @ts-expect-error I'm not sure quite how to appease TypeScript, but we've thoroughly checked types above
                    config[key] = entry.value;
                }
            }
            return config;
        }
        catch (error) {
            console.error('!!!', error);
        }
    }
    return APP_CONFIG_DEFAULTS;
});
